import { createColumnHelper } from '@tanstack/react-table';

import { renderStatus } from 'routes/portal/Items/itemsColumns';
import { EquipmentUnit } from 'types/equipment';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<EquipmentUnit>();

/**
 * One row per equipment unit on Unit Tracking (ClickUp 86bc4et79), laid out
 * like the Items table.
 */
export const buildEquipmentInventoryColumns = () => [
  col.accessor((unit) => unit?.code || '-', {
    id: 'code',
    header: 'Unit ID',
    minSize: 220,
  }),
  col.accessor((unit) => unit?.sku?.name || '-', {
    id: 'name',
    header: 'SKU Name',
    minSize: 180,
  }),
  col.accessor((unit) => unit?.sku?.category || '-', {
    id: 'category',
    header: 'Category',
    minSize: 150,
  }),
  col.accessor((unit) => renderStatus(unit?.status), {
    id: 'status',
    header: 'Status',
    minSize: 100,
  }),
  col.accessor(
    (unit) =>
      unit?.createdAt ? convertUTCToLocal(unit.createdAt, true, true) : '-',
    { id: 'createdAt', header: 'Added', minSize: 120 },
  ),
  col.accessor(
    (unit) =>
      unit?.lastMovedAt ? convertUTCToLocal(unit.lastMovedAt, true, true) : '-',
    { id: 'lastMovedAt', header: 'Last Moved', minSize: 120 },
  ),
  // The site a delivered unit is at, as the Items table shows it.
  col.accessor((unit) => unit?.currentVenue?.name || '-', {
    id: 'currentVenue',
    header: 'Last Venue',
    minSize: 150,
  }),
];
